import React, { useEffect } from 'react';
import useQuery from '../../app/common/util/hooks';
import { useStore } from '../../app/stores/store';
import { Grid, Link, Typography } from '@mui/material';
import { withNavbar } from '../../app/layout/HOC';
import { router } from '../../app/router/Routes';


function RegisterSuccess() {
    const { userStore } = useStore();
    const { user } = userStore;
    const email = useQuery().get('email') as string;
    // const displayName = useQuery().get('displayName') as string;

    useEffect(() => {
        if (user) {
            router.navigate('/')
        }
    }, [user])

    if (!email) router.navigate('/');
    // if (!email || !displayName) router.navigate('/');
    return (
        <Grid container justifyContent="center" alignItems='center' sx={{ bgcolor: '#f8faff', height: 480, marginTop: 12, }}>
            <Grid item xs={8}>
                <Typography variant="body1">Hi!, Your profile is successfully completed!</Typography>
                <Typography variant="body1">You can login now!</Typography>
                <Link href="/" onClick={() => router.navigate('/')}>
                    Go to home
                </Link>                
            </Grid>
        </Grid>
    )
}

const RegisterSuccessPage = withNavbar(RegisterSuccess);

export default RegisterSuccessPage;

